import { EyeIcon } from '@heroicons/react/24/solid'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import { LoadingData } from '../../components/Loading';
import Pagination from '../../components/Pagination';

export default function Users({ type }) {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [page, setPage ] = useState(1);
  const [selectedUser, setSelectedUser] = useState({});
  const [loading, setLoading] = useState(false);

  const serverData = useLoaderData()
  const navigate = useNavigate();

  useEffect(() => {
    setData(serverData)
    return () => {}
  }, [serverData])

  useEffect(() => {
    if (data && data.docs) {
      setUsers(data?.docs);
    }
  }, [data])


  return (
    <div className="w-full">
      <h4 className="text-xl font-fira font-semibold capitalize">{type === 'basic' ? 'Users' : 'Neutrals'}</h4>
      <div className="mt-6 bg-white pt-3 rounded-lg">
        <div className="">
          <div className="px-4 mb-4 flex justify-between items-center">
            <h4 className="text-sm font-semibold font-fira text-gray-800">All {type === 'basic' ? 'Users' : 'Neutrals'}</h4>
            <h4 className="text-xs font-semibold text-gray-800">Current Page {page}</h4>
          </div>
          <div className="w-full overflow-x-scroll">
            <table className="min-w-max w-full table-auto">
              <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                <tr>
                  <th className="py-3 px-8 text-left">Profile</th>
                  <th className="py-3 px-8 text-left">Date Joined</th>
                  <th className="py-3 px-8 text-left">Case Resolutions</th>
                  <th className="py-3 px-8 text-left">Status</th>
                  <th className="py-3 px-8 text-left"></th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (<tr key={user._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <div className="flex gap-2 items-center justify-center">
                      <img src={user.avatar} alt="avatar" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                      <div>
                        <h4 className="text-xs font-semibold">{user.name}</h4>
                        <a className="text-xs text-blue-900" href={`mailto:${user.email}`}>{user.email}</a>
                      </div>
                    </div>
                  </td>
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span>{moment(user.createdAt).fromNow()}</span>
                  </td>
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span>{user.cases}</span>
                  </td>

                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span className='text-green-900'>{user.verified ? 'Active' : 'Unverified'}</span>
                  </td>

                  <td className='py-3 px-8 text-left hover:text-blue-900 whitespace-nowrap'>
                    <Link to={`/admin/user/${user._id}`} className='flex gap-1 items-center'>
                      <span>
                        <EyeIcon className="h-4 w-4" />
                      </span>
                      <span className='whitespace-nowrap' >See Profile</span>
                    </Link>
                  </td>
                </tr>))}
              </tbody>
            </table>
          </div>
          {(users.length < 1 && !loading) && <div className="no-case flex py-8 px-6 flex-col justify-center gap-6">
            <div className="text-center">
              <h4 className="font-semibold font-fira text-lg">No {type === 'basic' ? 'User' : 'Neutral'} Record</h4>
            </div>
          </div>}
          {loading && <div className="mt-10">
            <LoadingData message="Loading Users..." />
          </div>}
        </div>
      </div>
      {<Pagination currentData={data} setData={setData} setLoading={setLoading} />}
    </div>
  )
}
